<form *ngIf="!formInformationMsg?.available" id="emailSignupForm" class="email-signup__form"
    aria-label="Email Signup" #emailSignupForm="ngForm" (submit)="signUp(emailSignupForm)" [ngClass]="{'calia': chainAbbr === 'calia' }">
    <div class="email-signup-contain">
        <div class="email-signup-text-box">
            <mat-form-field
                [ngClass]="{'error-input': submitted && (formInformationMsg?.emailAvailability || emailAddressInput?.errors) }">
                <input type="email" [(ngModel)]="emailAddress" name="emailAddressInput"
                    id="emailAddressInput" matInput placeholder="Email Address"
                    #emailAddressInput="ngModel"
                    pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}"
                    aria-describedby="email_message">
            </mat-form-field>
        </div>
        <button id="DSG_MarketingEmailSignupForm_Button"
            class="btn btn-block text-uppercase dcsg-button dcsg-button-primary email-signup__button"
            data-em="Footer_NewCustomer_EmailSignup">Sign Up</button>
        <div id="email_message" class="email-message-container">
            <div *ngIf="emailAddressInput?.errors && submitted && (emailAddressInput?.dirty || emailAddressInput?.touched) && !formInformationMsg?.emailEmptyErrorMsg"
                class="alert-danger">
                <div [hidden]="!emailAddressInput?.errors?.pattern">
                    <span>Please enter an email in the format username&#64;domain.com</span>
                </div>
            </div>
            <div *ngIf="formInformationMsg?.emailEmptyErrorMsg"
                class="email-message error-email-message">
                <span>Please enter an email in the format username&#64;domain.com</span>
            </div>
            <div *ngIf="formInformationMsg?.emailAvailability"
                class="email-message error-email-message">
                <span>{{formInformationMsg?.errorMsg}}</span>
            </div>
        </div>
    </div>

</form>
<div [ngClass]="returnStylesForEmailSignUp(data.textColor)">
    <div *ngIf="formInformationMsg.available" class="email-message success-email-message">

        <p *ngIf="formInformationMsg.subscribe">

            <span>Success!</span>
            <span>
                {{emailSuccess}} {{emailAddress}}.
            </span>

        </p>

        <p *ngIf="formInformationMsg.resubscribe"><span>Welcome back!</span> You've already received this offer. You have been resubscribed to receive other offers.</p>
    </div>

    <p class="footnote"><sup>*</sup> Online only. First-time subscribers only. Returning subscribers will be resubscribed for marketing/promo emails.</p>
</div>